export default {
  // baseUrl: 'http://192.168.0.186:8020/api/',
  // baseUrl: 'http://119.91.60.236/api/',
  baseUrl: 'https://67fi2k.lafyun.com:443',
}
